import React, { Component, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga";
import ScrollToTop from "./lib/ScrollToTop";
import InitCodeList from "./lib/InitCodeList";
import AutoLogin from "./lib/AutoLogin";
import RouteChangeTracker from "./lib/RouteChangeTracker";

import BuddibleSocket, { MsgIDList } from "./lib/BuddibleSocket";

/*계정 페이지*/
import FindID from "./main/findAccount/FindID";
import FindPW from "./main/findAccount/FindPW";
import DeleteAccount from "./account/DeleteAccount";
/*메인 페이지*/
import Main2 from "./main/main2/Main2";
/*스케줄*/
import ScheduleLCL from "./main/mall/schedule/LCL/ScheduleLCL";
import ScheduleFCL from "./main/mall/schedule/FCL/ScheduleFCL";
import ScheduleAIR from "./main/mall/schedule/AIR/ScheduleAIR";
import ReserveAIR from "./main/mall/schedule/AIR/ReserveAIR";
import ReserveFCL from "./main/mall/schedule/FCL/ReserveFCL";

/*서비스 소개*/
import Info from "./main/info/Info";
import LogiTalkLanding from "./logiTalkLanding/LogiTalkLanding";
import LogiWorkLanding from "./logiWorkLanding/LogiWorkLanding";
/*보세창고몰*/
import StoreMallMain from "./storeMall/StoreMallMain";
/*게시글 페이지*/
import PostMain from "./post/PostMain";
import PostList from "./post/components/PostList";
import PostDetail from "./post/components/PostDetail";
import WritePost from "./post/components/WritePost";
import WriteLogiStory from "./post/components/WriteLogiStory"; //PostDetail에서 수정 시 사용
/*홍보영상센터*/
import AdvertiseVideoCenter from "./advertiseVideoCenter/AdvertiseVideoCenter";
/*로지톡*/
import LogiTalk from "./logiTalk/LogiTalk"; //todo 다국어
import LogiTalkChatRoomPop from "./logiTalk/chat/LogiTalkChatRoomPop";
import ChatNewsDetail from "./logiTalk/chatNews/ChatNewsDetail";
import CorpInfoReferencePrint from "./logiTalk/corpInfoReference/CorpInfoReferencePrint";
/*todo 로지톡 코드정리,다국어*/
import LogiTalk2 from "./logiTalk2/LogiTalk";

/*ERP*/
import ERP from "./erp/ERP";
/*약관*/
import Terms from "./main/terms/Terms"; //todo 다국어 및 코드 정리

/*로지웍 Booking 탭*/
import ScheduleLogiWork from "./main/mall/schedule_logiwork/ScheduleLogiWork";
import ScheduleLogiWorkCost from "./main/mall/schedule_logiwork/ScheduleLogiWorkCost";
import ScheduleLogiWorkReserveMemo from "./main/mall/schedule_logiwork/ScheduleLogiWorkReserveMemo";
/*로지웍 업체별 알림 설정*/
import AlarmTalkManage from "./logiWork/alarmTalkManage/AlarmTalkManage";

/*베스트 관세법인 Report*/
import PublicReport from "./publicReport/PublicReport";
import PublicReportDetail from "./publicReport/PublicReportDetail";

/*로지톡 앱 웹뷰*/
import AppWebViewLogiWork from "./logiTalk/webView/logiWork/AppWebViewLogiWork";
import AppWebViewNews from "./logiTalk/webView/news/AppWebViewNews";
import AppWebViewNewsDetail from "./logiTalk/webView/news/components/AppWebViewNewsDetail";
import AppWebViewSearchUser from "./logiTalk/webView/searchUser/AppWebViewSearchUser";
/*----------------*/

import AboutGBTS from "./main/aboutGBTS/AboutGBTS";

// LogiTalk App WebView
// todo 테스트파일 삭제
import Test from "./test/Test"; //news screen
import Monitoring from "./hardware_monitoring/Monitoring";

ReactGA.initialize("UA-221040546-1");

class App extends Component {
  constructor(props) {
    super(props);
    this.socket = new BuddibleSocket();
    this.state = {
      isLoadingFinished: true,
      loadingOpen: false,
    };
  }

  componentDidMount() {
    this.socket.fireLocalEventListener(
      MsgIDList.EVENT_LOADING_INDICATOR,
      "App",
      this.loadingOpenHandler
    );

    //this.initFinished();
  }

  componentWillUnmount() {
    localStorage.removeItem("mallFilter");
  }

  initFinished = () => {
    this.setState({ isLoadingFinished: true });
  };

  loadingOpenHandler = (v) => {
    this.setState({
      loadingOpen: v,
    });
  };

  render() {
    if (!this.state.isLoadingFinished) {
      return (
        <div id="wrap">
          <InitCodeList initFinished={this.initFinished} />
        </div>
      );
    }

    if (document.getElementById("LoadingModalPage"))
      document.getElementById("LoadingModalPage").remove();

    return (
      <div id="wrap">
        <AppMain />
      </div>
    );
  }
}

const LangButton = (props) => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState("en");
  const pathname = window.location.pathname.toUpperCase().split("LOGITALK");
  const isDisplayNone =
    (pathname.length === 2 && (pathname[1] === "" || pathname[1] === "/")) ||
    pathname[0] === "/APPWEBVIEWNEWS" ||
    pathname[0] === "/APPWEBVIEWSEARCHUSER" ||
    pathname[0] === "/APPWEBVIEWLOGIWORK";

  console.log("pathname", pathname);

  useEffect(() => {
    i18n.changeLanguage("en");
  }, []);

  function changeLanguage() {
    let _lang = lang === "ko" ? "en" : "ko";
    i18n.changeLanguage(_lang, (err) => {});
    setLang(_lang);
  }

  return (
    <div
      id="btn-lang"
      className={`position-fixed ${isDisplayNone ? "d-none" : ""}`}
      style={{
        bottom: 25,
        right: 25,
        zIndex: 98,
      }}
    >
      <button
        className="btn btn-info rounded-circle text-center shadow"
        style={{
          width: "46px",
          height: "46px",
        }}
        onClick={changeLanguage}
      >
        {lang === "ko" ? "EN" : "KO"}
      </button>
    </div>
  );
};

function AppMain(props) {
  // console.log("AppMain");

  return (
    <>
      <AutoLogin />
      <InitCodeList />
      <BrowserRouter>
        <ScrollToTop />
        <LangButton />
        <RouteChangeTracker />
        <Routes>
          {/*계정관련 페이지*/}
          <Route path="/FindID" element={<FindID />} />
          <Route path="/FindPW" element={<FindPW />} />
          <Route path="/DeleteAccount" element={<DeleteAccount />} />
          {/*메인페이지*/}
          <Route path="/" element={<Main2 />} />
          <Route path="/gbts" element={<Main2 />} />
          <Route path="/freiscop" element={<Main2 />} />
          <Route path="/freiscop" element={<Main2 />} />
          {/*스케줄 페이지*/}
          <Route path="/ScheduleLCL" element={<ScheduleLCL />} />
          <Route path="/ScheduleLCL/:id" element={<ScheduleLCL />} />
          <Route path="/ScheduleFCL" element={<ScheduleFCL />} />
          <Route path="/ScheduleFCL/:id" element={<ScheduleFCL />} />
          <Route path="/ScheduleAIR" element={<ScheduleAIR />} />
          <Route path="/ScheduleAIR/:id" element={<ScheduleAIR />} />
          <Route path="/ReserveFCL/:id" element={<ReserveFCL />} />
          <Route path="/ReserveAIR/:id" element={<ReserveAIR />} />
          {/*서비스 소개*/}
          <Route path="/INFO" element={<Info />} />
          <Route path="/LogiTalkLanding" element={<LogiTalkLanding />} />
          <Route path="/LogiWorkLanding" element={<LogiWorkLanding />} />
          {/*보세창고*/}
          <Route path="/storeMall" element={<StoreMallMain />} />
          <Route path="/storeMall/:store_key" element={<StoreMallMain />} />
          <Route path="/freiscop/storeMall" element={<StoreMallMain />} />
          <Route
            path="/freiscop/storeMall/:store_key"
            element={<StoreMallMain />}
          />
          {/*게시글 페이지*/}
          <Route path="/PostMain" element={<PostMain />} />
          <Route path="/PostList/:post_type" element={<PostList />} />
          <Route path="/PostDetail/:post_type/:idx" element={<PostDetail />} />
          <Route path="/WritePost" element={<WritePost />} />
          <Route path="/WriteLogiStory/:idx" element={<WriteLogiStory />} />
          {/*홍보영상센터*/}
          <Route
            path="/AdvertiseVideoCenter"
            element={<AdvertiseVideoCenter />}
          />
          {/*로지톡*/}
          <Route path="/LogiTalk" element={<LogiTalk />} />
          <Route path="/LogiTalk2" element={<LogiTalk2 />} /> {/*todo*/}
          <Route
            path="/LogiTalkChatRoomPop/:crmMainKey"
            element={<LogiTalkChatRoomPop />}
          />
          <Route path="/LogiTalk/sno/:bizNum" element={<LogiTalk />} />
          <Route path="/ChatNewsDetail/:id" element={<ChatNewsDetail />} />
          <Route
            path="/LogiTalk/ChatNewsDetail/:id"
            element={<ChatNewsDetail />}
          />
          <Route
            path="/CorpInfoReferencePrint/:key"
            element={<CorpInfoReferencePrint />}
          />
          <Route
            path="/freiscop/CorpInfoReferencePrint/:key"
            element={<CorpInfoReferencePrint />}
          />
          {/*ERP*/}
          <Route path="/ERP" element={<ERP />} />
          <Route path="/ERP/:page" element={<ERP />} />
          {/*약관*/}
          <Route path="/Terms/:terms_type" element={<Terms />} />
          {/*로지웍 Booking 탭*/}
          <Route path="/freiscop/schedule" element={<ScheduleLogiWork />} />
          <Route
            path="/freiscop/schedule/:type"
            element={<ScheduleLogiWork />}
          />
          <Route
            path="/freiscop/ScheduleLogiWorkCost/:type/:idx/:realTime"
            element={<ScheduleLogiWorkCost />}
          />
          <Route
            path="/freiscop/ScheduleLogiWorkReserveMemo/:exp_imp/:type"
            element={<ScheduleLogiWorkReserveMemo />}
          />
          <Route
            path="/freiscop/ScheduleLogiWorkReserveMemo/:type/:idx"
            element={<ScheduleLogiWorkReserveMemo />}
          />
          {/*로지웍 업체별 알림 설정*/}
          <Route path="/AlarmTalkManage" element={<AlarmTalkManage />} />
          {/*베스트관세법입 : Report*/}
          <Route path="/PublicReport" element={<PublicReport />} />
          <Route
            path="/PublicReportDetail/:id"
            element={<PublicReportDetail />}
          />
          {/*로지톡 앱 웹뷰*/}
          <Route path="/AppWebViewLogiWork" element={<AppWebViewLogiWork />} />
          <Route path="/AppWebViewNews" element={<AppWebViewNews />} />
          <Route
            path="/AppWebViewNewsDetail"
            element={<AppWebViewNewsDetail />}
          />
          <Route
            path="/AppWebViewNewsDetail/:idx"
            element={<AppWebViewNewsDetail />}
          />
          <Route
            path="/AppWebViewSearchUser"
            element={<AppWebViewSearchUser />}
          />
          {/*---------------------*/}
          <Route path="/aboutGBTS" element={<AboutGBTS />} />
          {/*------------------------todo 아래 경로 정리 필요(240125.Amber)*/}
          <Route path="/Test" element={<Test />} />
          <Route path="/Monitoring" element={<Monitoring />} />
          {/*---------------------*/}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
